import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Breadcrumb,
  Modal,
  Form,
  FormGroup,
  Col,
  ControlLabel,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'
import { Typeahead } from 'react-bootstrap-typeahead'
import { browserHistory } from 'react-router'

import Collapsible from './../collapsible'
import Validators from '../../utils/validators'
import NewCompanyForm from './newcompanyform'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'companies', 'users', 'globals'])
export default class CompanyTable extends Component {

  constructor(props) {
    super(props)

    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))

    this.onSelectAll = this.onSelectAll.bind(this)
    this.onRowSelect = this.onRowSelect.bind(this)

    this.state = {
      showNewCompanyForm: false,
      showMassRepAssignModal: false,
      newCompanyName: '',
      newSourceId: 1,
      newVendorId: 1,
      newUserId: 1,
      newState: 1,
      selectAllOverride: true,
      selectAll: false,
      selected: [],
      currPage: 1,
      prevPage: 1,
      userId: 0,
      userFullName: '',
      loadableState: false
    }
  }

  /*
  selectAllOnPage(e) {
    const newSelectAllState = !this.state.selectAll
    this.setState({
      selectAllOverride: true,
      selectAll: newSelectAllState
    })

    const cb = document.getElementsByName('cbDuedate')

    for (let i=0; i<cb.length; i++) {
      eval('this.setState({cb_' + cb[i].value + ': newSelectAllState})')
    }
  }
  */

  openMassRepAssign() {
    const rows = this.state.selected
    let numRowsSelected = rows.length

    if (numRowsSelected < 1) {
      alert('Please select at least one row.')
    } else {
      let dd = new Date()
      let dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
      this.setState({
        showMassRepAssignModal: true,
        formattedMassDueDate: dateString
      })
    }
  }

  closeMassRepAssign() {
    this.setState({
      showMassRepAssignModal: false,
      formattedMassDueDate: ''
    })
  }

  saveMassRepAssign(e) {
    this.setState({
      loadableState: true
    })

    const rows = this.state.selected

    let promiseVariable = new Promise((resolve, reject) => {
      for( let i = 0; i<rows.length; i++ ) {
        const params = {
          id: rows[i],
          userId: this.state.userId,
          hash: localStorage.getItem('userHash')
        }
  
        this.props.companies.updateAssignedUser(params, () => {
          if (i == (rows.length-1)) {
            resolve()
          }
        })
      }
    });
    
    promiseVariable.then((data) => {
      this.props.reload(this.props.companyStateId, () => {
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
      })
    }).catch((err) => {
        alert('Something happened!  Please try again.  If the problem persists contact MC3 Solutions.')
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
    })

    this.closeMassRepAssign(e)
  }

  formatCheckbox(cell, row) {
    let checkedText = ''

    if (this.state.selectAllOverride) {
      checkedText = this.state.selectAll ? 'checked' : ''
    } else if (eval('this.state.cb_' + cell + ' != undefined')) {
      checkedText = eval('this.state.cb_' + cell) ? 'checked' : ''
    }

    return (
      <div>
        <input type="checkbox" name="cbDuedate" value={ cell } checked={ checkedText } onChange={ this.checkboxChanged.bind(this) } />
      </div>
    )
  }

  checkboxChanged(e) {
    this.setState({
      selectAllOverride: false
    })

    if (eval('this.state.cb_' + e.target.value + ' != undefined')) {
      eval('this.setState({ cb_' + e.target.value + ': !this.state.cb_' + e.target.value + ' })')
    } else {
      eval('this.setState({ cb_' + e.target.value + ': e.target.checked })')
    }
  }

  onRowSelect({ id }, isSelected) {
    if (isSelected) {
      const currPage = this.refs.table.state.currPage

      if (currPage != this.state.prevPage) {
        this.setState({
          selected: [],
          prevPage: currPage
        })
      }

      this.setState({
        selected: [ ...this.state.selected, id ].sort(),
        currPage: this.refs.table.state.currPage
      });
    } else {
      this.setState({ selected: this.state.selected.filter(it => it !== id) });
    }

    return false;
  }

  onSelectAll(isSelected) {
      
    let rows = []

    if (isSelected) {
      rows = this.refs.table.state.data.map(row => row.id)
    }

    this.setState({
      selected: rows
    })

    return rows
  }

  openNewCompanyForm() {
    this.setState({
      showNewCompanyForm: true
    })
  }

  closeNewCompanyForm() {
    this.setState({
      showNewCompanyForm: false
    })
  }

  onRowClick(row) {
    browserHistory.push('/companies/' + row.id)
  }

  deleteCompany(id) {
    if (confirm('Are you sure you want to delete this ' + this.props.companyStateHeading + '?')) {
      this.props.companies.deleteCompany({
        id: id,
        hash: localStorage.getItem('userHash')
      }, () => {
        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 4, id, 3, localStorage.getItem('userOrganizationId'))

        this.props.reload(this.props.companyStateId)
      })
    }
  }

  formatActions(cell, row) {
    /*
    let createQuoteButton = ''

    if (this.props.companyStateId != 1) {
        createQuoteButton = <Button bsSize="small" bsStyle="info" id={ cell } onClick={ () => { browserHistory.push('/company/createquote/' + row.id) } }><i className="fa fa-money" aria-hidden="true"></i></Button>
    }
    */

    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'viewCompany-' + cell}>View { this.props.companyStateHeading }</Tooltip> }><Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { browserHistory.push('/company/details/' + row.id) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button></OverlayTrigger>
        { /* createQuoteButton */ }
        { /* <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCompany(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button> */ }
      </div>
    )
  }

  onUserChanged(e) {
    if (e.length > 0) {
      this.setState({
        userId: e[0].id,
        userFullName: e[0].name
      })
    } else {
      this.setState({
        userId: 0,
        userFullName: ''
      })
    }
  }

  render() {
    const selectAllText = this.state.selectAll ? 'Unselect' : 'Select'
    const options = {
      defaultSortName: 'name',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }
    const selectRowProp = {
      mode: 'checkbox',
      onSelect: this.onRowSelect,
      onSelectAll: this.onSelectAll,
      selected: this.state.selected,
      columnWidth: '15px'
    }

    let companyTable = 'No results found!'
    
    let accessLevel = localStorage.getItem('userAccessLevel')
    if (this.props.data.length >= 0) {
        companyTable = (
        <div>
          {accessLevel >= 15 && (this.props.companyStateHeading !== 'Make a selection above') ? <Button bsStyle="warning" onClick={ this.openMassRepAssign.bind(this) }>Reassign User for Selected Companies</Button> : null}
          {accessLevel == 5 && (this.props.companyStateHeading === 'Lead' || this.props.companyStateHeading === 'Customer') ? <Button bsStyle="info" onClick={this.openNewCompanyForm.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> Create New { this.props.companyStateHeading }</Button> : null}
          {accessLevel >= 15 && (this.props.companyStateHeading !== 'Make a selection above') ? <Button bsStyle="info" onClick={this.openNewCompanyForm.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> Create New { this.props.companyStateHeading }</Button> : null}
          {this.props.data.length > 0 ? <BootstrapTable
              data={ this.props.data }
              striped={ true }
              hover={ true }
              pagination={ true }
              search={ true }
              exportCSV={ true }
              options={ options }
              bordered={ true }
              selectRow={ selectRowProp }
              ref="table"
              >
            <TableHeaderColumn width="50" dataField="id" hidden isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true } filter={ { type: 'TextFilter', delay: 50 } }>ID</TableHeaderColumn>
            <TableHeaderColumn width="25" dataField="id" hidden dataAlign="center" hiddenOnInsert={ true } dataFormat={ this.formatCheckbox.bind(this) } autoValue={ true } filter={ { type: 'TextFilter', delay: 50 } }></TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>{ this.props.companyStateHeading }</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Fullname</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="email" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Email</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="phone" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Phone</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="address" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Address</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="userFullName" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Assigned</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Vendor</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="sourceName" dataSort={ true } editable={{ validator: Validators.validString }} filter={ { type: 'TextFilter', delay: 50 } }>Source</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable> : null}
        </div>
      )
    }

    return (
      <div>
        <div>
          <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
            <Collapsible title={ this.props.companyStateHeading } content={ companyTable } />
          </Loadable>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div>
          <NewCompanyForm companyStateId={ this.props.companyStateId } showNewCompanyForm={ this.state.showNewCompanyForm } companyStateHeading={ this.props.companyStateHeading } onClose={ this.closeNewCompanyForm.bind(this) } />
        </div>
        <div>
          <Modal show={ this.state.showMassRepAssignModal } onHide={ this.closeMassRepAssign.bind(this) }>
            <Modal.Header closeButton>
              <Modal.Title>Update Assigned Rep</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal name="massRepAssignForm">
                <FormGroup>
                <Col componentClass={ ControlLabel } sm={ 4 }>Assigned Rep:</Col>
                <Col sm={ 8 }>
                  <FormGroup>
                    <Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onUserChanged.bind(this) } selected={ [{ id: this.state.userId, name: this.state.userFullName }] } placeholder="Choose a user..." />
                  </FormGroup>
                </Col>
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={ this.closeMassRepAssign.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
              <Button bsStyle="success" onClick={ this.saveMassRepAssign.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/companies/companytable.js